export default "__VITE_ASSET__a60cd55b__"